<script setup lang="ts">
import type { StudyModel } from '@/models/study';
import type { PropType } from 'vue';

defineProps({
  studies: {
    type: Array as PropType<StudyModel[]>,
    required: true
  }
});

const emit = defineEmits(['studyClick']);

const setSelected = (item: StudyModel) => {
  emit('studyClick', item);
};
</script>

<template>
    <div class="study-selector-popup" ref="target">
      <ul>
        <li v-for="item in studies"
          @click="setSelected(item)"
          :key="item.identifier">
          {{ item.title }}
        </li>
      </ul>
    </div>
</template>

<style scoped lang="scss">
.study-selector-popup{
  max-height: 90vh;
  overflow: auto;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
}
li {
  padding: 12px;
  text-wrap: nowrap;
  cursor: pointer;
  &:hover {
    background: hsla(0, 0%, 0%, 0.14);
  }
}
.current {
    background: hsla(0, 0%, 0%, 0.24);
}
</style>
